import React from 'react';

import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import {
  gray100,
  red10,
  red100,
  primary10,
  primaryColor
} from '../../constants/Colors';

import type { AlertProps } from '@mui/material/Alert';

const styles = {
  alertBg: {
    '& .MuiAlert-icon': {
      color: red100
    },
    backgroundColor: red10,
    border: `1px solid ${red100}`,
    color: gray100,
    fontSize: '14px',
    whiteSpace: 'break-spaces'
  },
  infoBg: {
    '& .MuiAlert-icon': {
      color: primaryColor
    },
    backgroundColor: primary10,
    border: `1px solid ${primaryColor}`,
    color: gray100,
    fontSize: '14px'
  }
};

const Alert = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert sx={styles.alertBg} ref={ref} {...props} />
));

const Info = React.forwardRef<HTMLDivElement, AlertProps>((props, ref) => (
  <MuiAlert sx={styles.infoBg} ref={ref} {...props} />
));

type SnackbarProps = React.ComponentProps<typeof Snackbar>;

type Props = SnackbarProps & {
  text: string;
  infoText?: string | undefined | null;
  closeButton?: () => void;
};

const CustomSnackbar: React.FC<Props> = (props) => {
  const { text, infoText, closeButton, ...rest } = props;

  return (
    <>
      {text && (
        <Snackbar {...rest}>
          <Alert
            severity="error"
            {...(closeButton && { onClose: closeButton })}
          >
            {text}
          </Alert>
        </Snackbar>
      )}
      {infoText && (
        <Snackbar {...rest}>
          <Info severity="info" {...(closeButton && { onClose: closeButton })}>
            {infoText}
          </Info>
        </Snackbar>
      )}
    </>
  );
};

export default CustomSnackbar;
